/** One dot on the timeline spine. A focused row's dot flashes for a moment. */
export function SpineDot({
  colorClass,
  flash,
}: {
  colorClass: string
  flash: boolean
}) {
  return (
    <span className="relative mt-2 flex h-2 w-2 flex-shrink-0">
      {flash && (
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75 [animation-duration:500ms] [animation-iteration-count:3]" />
      )}
      <span
        className={`relative inline-flex h-2 w-2 rounded-full ${flash ? 'bg-primary' : colorClass}`}
      />
    </span>
  )
}
